import { useQuery } from "@obvio/app";

import type { Schema } from "@obvio/app";
import type { DeepPick } from "@obvio/utils";

export const ARTICLE_CATEGORY_SELECT = {
  id: true,
  createdAt: true,
  title: true,
} as const;

export type ARTICLE_DATA = DeepPick<
  Schema["ArticleCategory"],
  typeof ARTICLE_CATEGORY_SELECT
>;

type query = typeof useQuery<
  "getArticleCategories",
  typeof ARTICLE_CATEGORY_SELECT,
  { select: typeof ARTICLE_CATEGORY_SELECT }
  >;

export function useArticleCategories(): ReturnType<query> {
  return useQuery("getArticleCategories", {
    select: ARTICLE_CATEGORY_SELECT,
  });
}
